import { useTaxonomies } from '@gik/api/give/taxonomies';
import { FetchProvider } from '@gik/core/components/DynamicComponent/FetchProvider';
import type { WordpressTaxonomy } from '@gik/core/models/wordpress/WordpressTaxonomy';
import type { UIComponent } from '@gik/core/types/UI';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import React from 'react';
import type { GiveSituationsGridProps } from '../SituationsGrid/GiveSituationsGrid';
import { GiveSituationsGridWithNavSkeleton, SituationsGridWithNav } from './SituationsGridWithNav';

export type SituationsGridWithNavWithDataProps = {
  fallbackData?: WordpressTaxonomy[];
} & UIComponent;

function SituationsGridWithNavWithDataComp(props: GiveSituationsGridProps) {
  const { taxonomyType, parentTaxonomy, items } = props;

  const useFetch = () => {
    return useTaxonomies('situation', null, {
      fallbackData: items,
    });
  };

  return (
    <FetchProvider
      fetch={useFetch}
      transform={data => data.sort((a, b) => parseInt(a.acf.weighting) - parseInt(b.acf.weighting))}
      loadingComponent={<GiveSituationsGridWithNavSkeleton {...props} />}
    >
      {({ data }) => (
        <SituationsGridWithNav {...props} items={data} taxonomyType={taxonomyType} parentTaxonomy={parentTaxonomy} />
      )}
    </FetchProvider>
  );
}

export const SituationsGridWithNavWithData = withComponentErrorBoundary(SituationsGridWithNavWithDataComp);
